/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class EmployeeService implements IEmpService {
    public static $inject = ['$http', '$state', 'Api', 'User', 'Orgs', 'Login', 'Process'];

    private employees = {
        loading: false,
        list: [],
        count: 0
    };

    private subord_candidates = {
        loading: false,
        list: [],
        count: 0
    };

    private employeeNames = {
        loading: false,
        list: [],
        promise: undefined
    }

    public filters: any = {};
    public filters_change_flag: any = {flag: 0};  // Used to monitor changes to filters
    public query: string = '';
    public query_email: string = '';
    public query_all_emp: boolean = false;  // Used for searching active and terminated employees in SSA search

    public test_data: any = {
        status: true,
        data: {
            document_type: 'VN',
            surname: 'SEGUYA',
            given_names: 'DOUGLAS',
            document_no: 'B0955844',
            country: 'USA',
            sex: 'M',
            date_of_birth: '850421',
            date_of_expiry: '150515',
            scan_image: 'https://accurascan.com/public/uploads/scan_img/1524836420_douglas_visa.jpg'
        }
    };

    private availableFilters = {
        nationality: {
            name: 'Nationality',
            notInExtra: true,
            type: 'checkbox',
            options: [{name: '---', value: '---'}, {'name': 'Afghan', 'value': 'Afghan'}, {'name': 'Albanian', 'value': 'Albanian'}, {'name': 'Algerian', 'value': 'Algerian'}, {'name': 'American', 'value': 'American'}, {'name': 'Andorran', 'value': 'Andorran'}, {'name': 'Angolan', 'value': 'Angolan'}, {'name': 'Antiguans', 'value': 'Antiguans'}, {'name': 'Argentinean', 'value': 'Argentinean'}, {'name': 'Armenian', 'value': 'Armenian'}, {'name': 'Australian', 'value': 'Australian'}, {'name': 'Austrian', 'value': 'Austrian'}, {'name': 'Azerbaijani', 'value': 'Azerbaijani'}, {'name': 'Bahamian', 'value': 'Bahamian'}, {'name': 'Bahraini', 'value': 'Bahraini'}, {'name': 'Bangladeshi', 'value': 'Bangladeshi'}, {'name': 'Barbadian', 'value': 'Barbadian'}, {'name': 'Barbudans', 'value': 'Barbudans'}, {'name': 'Batswana', 'value': 'Batswana'}, {'name': 'Belarusian', 'value': 'Belarusian'}, {'name': 'Belgian', 'value': 'Belgian'}, {'name': 'Belizean', 'value': 'Belizean'}, {'name': 'Beninese', 'value': 'Beninese'}, {'name': 'Bhutanese', 'value': 'Bhutanese'}, {'name': 'Bolivian', 'value': 'Bolivian'}, {'name': 'Bosnian', 'value': 'Bosnian'}, {'name': 'Brazilian', 'value': 'Brazilian'}, {'name': 'British', 'value': 'British'}, {'name': 'Bruneian', 'value': 'Bruneian'}, {'name': 'Bulgarian', 'value': 'Bulgarian'}, {'name': 'Burkinabe', 'value': 'Burkinabe'}, {'name': 'Burmese', 'value': 'Burmese'}, {'name': 'Burundian', 'value': 'Burundian'}, {'name': 'Cambodian', 'value': 'Cambodian'}, {'name': 'Cameroonian', 'value': 'Cameroonian'}, {'name': 'Canadian', 'value': 'Canadian'}, {'name': 'Cape Verdean', 'value': 'Cape Verdean'}, {'name': 'Central African', 'value': 'Central African'}, {'name': 'Chadian', 'value': 'Chadian'}, {'name': 'Chilean', 'value': 'Chilean'}, {'name': 'Chinese', 'value': 'Chinese'}, {'name': 'Colombian', 'value': 'Colombian'}, {'name': 'Comoran', 'value': 'Comoran'}, {'name': 'Congolese', 'value': 'Congolese'}, {'name': 'Costa Rican', 'value': 'Costa Rican'}, {'name': 'Croatian', 'value': 'Croatian'}, {'name': 'Cuban', 'value': 'Cuban'}, {'name': 'Cypriot', 'value': 'Cypriot'}, {'name': 'Czech', 'value': 'Czech'}, {'name': 'Danish', 'value': 'Danish'}, {'name': 'Djibouti', 'value': 'Djibouti'}, {'name': 'Dominican', 'value': 'Dominican'}, {'name': 'Dutch', 'value': 'Dutch'}, {'name': 'East Timorese', 'value': 'East Timorese'}, {'name': 'Ecuadorean', 'value': 'Ecuadorean'}, {'name': 'Egyptian', 'value': 'Egyptian'}, {'name': 'Emirian', 'value': 'Emirian'}, {'name': 'Equatorial Guinean', 'value': 'Equatorial Guinean'}, {'name': 'Eritrean', 'value': 'Eritrean'}, {'name': 'Estonian', 'value': 'Estonian'}, {'name': 'Ethiopian', 'value': 'Ethiopian'}, {'name': 'Fijian', 'value': 'Fijian'}, {'name': 'Filipino', 'value': 'Filipino'}, {'name': 'Finnish', 'value': 'Finnish'}, {'name': 'French', 'value': 'French'}, {'name': 'Gabonese', 'value': 'Gabonese'}, {'name': 'Gambian', 'value': 'Gambian'}, {'name': 'Georgian', 'value': 'Georgian'}, {'name': 'German', 'value': 'German'}, {'name': 'Ghanaian', 'value': 'Ghanaian'}, {'name': 'Greek', 'value': 'Greek'}, {'name': 'Grenadian', 'value': 'Grenadian'}, {'name': 'Guatemalan', 'value': 'Guatemalan'}, {'name': 'Guinea-Bissauan', 'value': 'Guinea-Bissauan'}, {'name': 'Guinean', 'value': 'Guinean'}, {'name': 'Guyanese', 'value': 'Guyanese'}, {'name': 'Haitian', 'value': 'Haitian'}, {'name': 'Herzegovinian', 'value': 'Herzegovinian'}, {'name': 'Honduran', 'value': 'Honduran'}, {'name': 'Hungarian', 'value': 'Hungarian'}, {'name': 'I-Kiribati', 'value': 'I-Kiribati'}, {'name': 'Icelander', 'value': 'Icelander'}, {'name': 'Indian', 'value': 'Indian'}, {'name': 'Indonesian', 'value': 'Indonesian'}, {'name': 'Iranian', 'value': 'Iranian'}, {'name': 'Iraqi', 'value': 'Iraqi'}, {'name': 'Irish', 'value': 'Irish'}, {'name': 'Israeli', 'value': 'Israeli'}, {'name': 'Italian', 'value': 'Italian'}, {'name': 'Ivorian', 'value': 'Ivorian'}, {'name': 'Jamaican', 'value': 'Jamaican'}, {'name': 'Japanese', 'value': 'Japanese'}, {'name': 'Jordanian', 'value': 'Jordanian'}, {'name': 'Kazakhstani', 'value': 'Kazakhstani'}, {'name': 'Kenyan', 'value': 'Kenyan'}, {'name': 'Kittian and Nevisian', 'value': 'Kittian and Nevisian'}, {'name': 'Kuwaiti', 'value': 'Kuwaiti'}, {'name': 'Kyrgyz', 'value': 'Kyrgyz'}, {'name': 'Laotian', 'value': 'Laotian'}, {'name': 'Latvian', 'value': 'Latvian'}, {'name': 'Lebanese', 'value': 'Lebanese'}, {'name': 'Liberian', 'value': 'Liberian'}, {'name': 'Libyan', 'value': 'Libyan'}, {'name': 'Liechtensteiner', 'value': 'Liechtensteiner'}, {'name': 'Lithuanian', 'value': 'Lithuanian'}, {'name': 'Luxembourger', 'value': 'Luxembourger'}, {'name': 'Macedonian', 'value': 'Macedonian'}, {'name': 'Malagasy', 'value': 'Malagasy'}, {'name': 'Malawian', 'value': 'Malawian'}, {'name': 'Malaysian', 'value': 'Malaysian'}, {'name': 'Maldivan', 'value': 'Maldivan'}, {'name': 'Malian', 'value': 'Malian'}, {'name': 'Maltese', 'value': 'Maltese'}, {'name': 'Marshallese', 'value': 'Marshallese'}, {'name': 'Mauritanian', 'value': 'Mauritanian'}, {'name': 'Mauritian', 'value': 'Mauritian'}, {'name': 'Mexican', 'value': 'Mexican'}, {'name': 'Micronesian', 'value': 'Micronesian'}, {'name': 'Moldovan', 'value': 'Moldovan'}, {'name': 'Monacan', 'value': 'Monacan'}, {'name': 'Mongolian', 'value': 'Mongolian'}, {'name': 'Moroccan', 'value': 'Moroccan'}, {'name': 'Mosotho', 'value': 'Mosotho'}, {'name': 'Motswana', 'value': 'Motswana'}, {'name': 'Mozambican', 'value': 'Mozambican'}, {'name': 'Namibian', 'value': 'Namibian'}, {'name': 'Nauruan', 'value': 'Nauruan'}, {'name': 'Nepalese', 'value': 'Nepalese'}, {'name': 'New Zealander', 'value': 'New Zealander'}, {'name': 'Nicaraguan', 'value': 'Nicaraguan'}, {'name': 'Nigerian', 'value': 'Nigerian'}, {'name': 'Nigerien', 'value': 'Nigerien'}, {'name': 'North Korean', 'value': 'North Korean'}, {'name': 'Northern Irish', 'value': 'Northern Irish'}, {'name': 'Norwegian', 'value': 'Norwegian'}, {'name': 'Omani', 'value': 'Omani'}, {'name': 'Pakistani', 'value': 'Pakistani'}, {'name': 'Palauan', 'value': 'Palauan'}, {'name': 'Panamanian', 'value': 'Panamanian'}, {'name': 'Papua New Guinean', 'value': 'Papua New Guinean'}, {'name': 'Paraguayan', 'value': 'Paraguayan'}, {'name': 'Peruvian', 'value': 'Peruvian'}, {'name': 'Polish', 'value': 'Polish'}, {'name': 'Portuguese', 'value': 'Portuguese'}, {'name': 'Qatari', 'value': 'Qatari'}, {'name': 'Romanian', 'value': 'Romanian'}, {'name': 'Russian', 'value': 'Russian'}, {'name': 'Rwandan', 'value': 'Rwandan'}, {'name': 'Saint Lucian', 'value': 'Saint Lucian'}, {'name': 'Salvadoran', 'value': 'Salvadoran'}, {'name': 'Samoan', 'value': 'Samoan'}, {'name': 'San Marinese', 'value': 'San Marinese'}, {'name': 'Sao Tomean', 'value': 'Sao Tomean'}, {'name': 'Saudi', 'value': 'Saudi'}, {'name': 'Scottish', 'value': 'Scottish'}, {'name': 'Senegalese', 'value': 'Senegalese'}, {'name': 'Serbian', 'value': 'Serbian'}, {'name': 'Seychellois', 'value': 'Seychellois'}, {'name': 'Sierra Leonean', 'value': 'Sierra Leonean'}, {'name': 'Singaporean', 'value': 'Singaporean'}, {'name': 'Slovakian', 'value': 'Slovakian'}, {'name': 'Slovenian', 'value': 'Slovenian'}, {'name': 'Solomon Islander', 'value': 'Solomon Islander'}, {'name': 'Somali', 'value': 'Somali'}, {'name': 'South African', 'value': 'South African'}, {'name': 'South Korean', 'value': 'South Korean'}, {'name': 'Spanish', 'value': 'Spanish'}, {'name': 'Sri Lankan', 'value': 'Sri Lankan'}, {'name': 'Sudanese', 'value': 'Sudanese'}, {'name': 'Surinamer', 'value': 'Surinamer'}, {'name': 'Swazi', 'value': 'Swazi'}, {'name': 'Swedish', 'value': 'Swedish'}, {'name': 'Swiss', 'value': 'Swiss'}, {'name': 'Syrian', 'value': 'Syrian'}, {'name': 'Taiwanese', 'value': 'Taiwanese'}, {'name': 'Tajik', 'value': 'Tajik'}, {'name': 'Tanzanian', 'value': 'Tanzanian'}, {'name': 'Thai', 'value': 'Thai'}, {'name': 'Togolese', 'value': 'Togolese'}, {'name': 'Tongan', 'value': 'Tongan'}, {'name': 'Trinidadian or Tobagonian', 'value': 'Trinidadian or Tobagonian'}, {'name': 'Tunisian', 'value': 'Tunisian'}, {'name': 'Turkish', 'value': 'Turkish'}, {'name': 'Tuvaluan', 'value': 'Tuvaluan'}, {'name': 'Ugandan', 'value': 'Ugandan'}, {'name': 'Ukrainian', 'value': 'Ukrainian'}, {'name': 'Uruguayan', 'value': 'Uruguayan'}, {'name': 'Uzbekistani', 'value': 'Uzbekistani'}, {'name': 'Venezuelan', 'value': 'Venezuelan'}, {'name': 'Vietnamese', 'value': 'Vietnamese'}, {'name': 'Welsh', 'value': 'Welsh'}, {'name': 'Yemenite', 'value': 'Yemenite'}, {'name': 'Zambian', 'value': 'Zambian'}, {'name': 'Zimbabwean', 'value': 'Zimbabwean'}]
        },
        gender: {
            name: 'Gender',
            notInExtra: true,
            options: [
                { value: 'male', name: 'Male' },
                { value: 'female', name: 'Female' },
                { value: '---', name: '---' }
            ]
        },
        age_group: {
            name: 'Age range',
            type: 'date_range',
            options: [
                { text: 'From', name: 'birth_date__lte' },
                { text: 'To', name: 'birth_date__gte' },
            ]
        },
        religion: {
            name: 'Religion',
            notInExtra: true,
            type: 'checkbox',
            options: [

                { value: 'christian', name: 'Christian' },
                { value: 'muslim', name: 'Muslim' },
                { value: 'hindu', name: 'Hindu' },
                { value: 'buddhist', name: 'Buddhist' },
                { value: 'sikh', name: 'Sikh' },
                { value: 'judaism', name: 'Judaism' },
                { value: 'chinese folk', name: 'Chinese Folk' },
                { value: 'other', name: 'other' },
                { value: '---', name: '---' },
            ]
        },
        business_licence: {
            name: 'Licenses',
            type: 'checkbox',
            notInExtra: true,
            options: [
            ]
        },
        management_role: {
            name: 'Management Roles',
            type: 'checkbox',
            notInExtra: true,
            options: [
                { value: 'department', name: 'Department manager' },
                { value: 'division', name: 'Division manager' },
                { value: 'office', name: 'Office manager' }
            ]
        },
        contract_type: {
            name: 'Contract',
            notInExtra: true,
            type: 'checkbox',
            options: [
                { value: 'full time', name: 'Full time' },
                { value: 'part time', name: 'Part time' },
                { value: 'contract', name: 'Contract' },
                { value: 'other', name: 'other' },
                { value: 'limited', name: 'limited' }                
            ]
        },
        benefits: {
            name: 'Benefits',
            type: 'checkbox',
            options: [],
            notInExtra: true,
        },
        office: {
            name: 'Office',
            options: [],
            type: 'checkbox',
            notInExtra: true,
        },
        division: {
            name: 'Division',
            type: 'checkbox',
            options: [],
            notInExtra: true
        },
        department: {
            name: 'Department',
            type: 'checkbox',
            options: [],
            notInExtra: true
        },
        terminated: {
            name: 'Terminated',
            notInExtra: true,
            options: [
                { value: 'active', name: 'Active' },
                { value: 'terminated', name: 'Terminated' },
                { value: 'both', name: 'Both' }
            ]
        }
    };

    public coTourStatus: Boolean = false;
    constructor(private $http: ng.IHttpService,
                private $state: ng.ui.IStateService,
                private Api: Restangular.IService,
                private User: IUserService,
                private Org: IOrgsService,
                private Login: ILoginService,
                private Process: IProcessService)
    {
        Api.setErrorInterceptor((response, deferred) => {
        if((response.data && response.data.detail === 'Authentication credentials were not provided.') && response.status === 403) {

              Login.logout().$promise.then(() => {
                  //cleaning user-id attr
                  angular.element('body').removeAttr('user-id')
                  User.clearUser();
                  $state.go('login');
              });
              return false;
            }
            return true;
        });
        this.cleanFilters()
        if (!this.User.getCurrentUser().userData.user.is_superuser) {
            this.Org.getMyOrg().then((org) => {
                this.availableFilters.office.options = (org.extra.offices || []).map((i) =>
                    ({name: i.name, value: i.name}))
                this.availableFilters.division.options = [].concat.apply([],
                    (org.extra.offices || []).map((o) => (o.divisions || []))).map((i) =>
                        ({name: i.name, value: i.name}))
                this.availableFilters.department.options = [].concat.apply([],
                    (org.extra.offices || []).map((o) => [].concat.apply([],
                        (o.divisions || []).map((d) => (d.departments || []))))).map((i) =>
                            ({name: i.name, value: i.name}))
            })
            this.list().then((employees) => {
                var nationalities = []
                for (var i=0; i < employees.results.length; i++) {
                    let e = employees.results[i]
                    let n = e.extra.personal.nationality
                    if (n && nationalities.indexOf(n) == -1) {
                        nationalities = nationalities.concat([n])
                    }
                }
                this.availableFilters.nationality.options = nationalities.map((n) =>
                    ({name: n, value: n}))
            })
        }
    }


    public list(org_id?: string, page = 1): Restangular.IPromise<any> {
        this.employees.loading = true;
        let promise = this.Api.all('employees').customGET("",
            this.convert(this.filters, page), org_id)

        promise.then((response: any) => {
            this.employees.loading = false;
            this.employees.list = response.results;
            this.employees.count = response.count;
            this.employees.list.map(emp => {
                emp.extra.image = emp.extra.image ? emp.extra.image : '/static/images/placeholder-nobody2.png'
            })
        });

        return promise;
    }

    public listSubordinateCandidates(org_id?: string): Restangular.IPromise<any> {
        this.subord_candidates.loading = true;
        let promise = this.Api.all('employees').customGET("", {org: org_id, 'list_all_subordinate_candidates': true})

        promise.then((response: any) => {
            this.subord_candidates.loading = false;
            this.subord_candidates.list = response.results;
            this.subord_candidates.count = response.count;
        });

        return promise;
    }

    public getObject(): any {
        return this.employees;
    }

    public loadEmployee(id: string): any {
        return this.Api.one('employees', id).get();
    }

    getByClearance(clearance: string): any {
        return this.Api.one('employees').get({"clearance": clearance});
    }

    getSupportEmail(): any {
        return this.Api.one('employees').one("support").get();
    }

    public getHistory(id: string): any {
        return this.Api.one('employees', id).one('history').get();
    }

    public loadSchema(): angular.IPromise<any> {
        return this.$http.get('/static/schemas/employee.schema.json');
    }

    public clean(): void {
        if (this.employees.list) {
            this.employees.list.length = 0;
        }
        this.employees.loading = false;
    }

    public setFilters(filters): void {
        this.filters = filters;
        this.filters_change_flag['flag'] += 1;
    }

    public cleanFilters(): void {
        this.filters = {}
        this.filters_change_flag['flag'] = 0;
    }

    public getFilters(): any {
        return this.filters
    }

    public setQuery(query: string): void {
      this.query = query
      this.query_all_emp = false;
    }

    public getQuery(): string {
      return this.query
    }

    public setQueryEmail(query_email: string): void {
      this.query_email = query_email
      this.query_all_emp = false;
    }

    public getQueryEmail(): string {
      return this.query_email
    }

    public setQueryAllEmp(all_emp: boolean): void {
      this.query_all_emp = all_emp;
    }

    public setAvailableFilters(availableFilters) {
        this.availableFilters = availableFilters;
    }

    public getAvailableFilters() {
        return this.availableFilters;
    }

    public terminate(emp: any, termination_reason: string, termination_date: string): Restangular.IPromise<any> {
        if (emp.active) {
            emp.active = false;
            emp.extra.employment = emp.extra.employment ? emp.extra.employment : {};
            emp.extra.employment.end_date = termination_date;
            emp.extra.employment.termination_reason = termination_reason;
            return emp.put()
        }
        return emp.get()
    }

    public activate(emp: any): Restangular.IPromise<any> {
        if (!emp.active) {
            emp.active = true
            emp.extra.employment.end_date = undefined
            return emp.put()
        }
        return emp.get()
    }

    public update_superior(emp: any, superior: any): Restangular.IPromise<any> {
        emp.superior = superior
        return emp.put()
    }

    public delete_leave(emp: any, id: any): Restangular.IPromise<any> {
        console.log('delete leave');
        for (let i =0; i < emp.extra.leaves.length; i++) {
            if (emp.extra.leaves[i].id &&  emp.extra.leaves[i].id == id) {                
                emp.extra.leaves[i].deleted = true;
                if (emp.extra.leaves[i].process){
                    this.Process.deleteProcess(emp.extra.leaves[i].process);
                } else {
                    return emp.put();
                }
                break;
            }
        }

        return emp.get();
    }

    public delete_arrival(emp: any, arrival: any): Restangular.IPromise<any> {
        for (let i =0; i < emp.extra.lateArrivals.length; i++) {

            // TODO: Use a proper ID field instead of create_data :: Awaiting API/Backend update
            if (emp.extra.lateArrivals[i].create_date == arrival.create_date) {
                emp.extra.lateArrivals[i].deleted = true;
                emp.extra.lateArrivals[i].deleted_on = moment().format('YYYY-MM-DD HH:mm:ss');
                break;
            }
        }

        return emp.put()
    }

    public delete_dependant(emp: any, dependant_index: number): Restangular.IPromise<any> {
        emp.extra.personal.dependants.splice(dependant_index, 1);
        return emp.put()
    }

    public archive_leave(emp: any, id: any): Restangular.IPromise<any> {
        for (let i =0; i < emp.extra.leaves.length; i++) {
            if (emp.extra.leaves[i].id &&  emp.extra.leaves[i].id == id) {
                emp.extra.leaves[i].archived = true;
                emp.extra.leaves[i].deleted = true;
                break;
            }
            if (emp.extra.leaves[i].process != undefined && emp.extra.leaves[i].process.process_id == id) {
              //TO DO
              return this.Api.one('processes', id).one('items').one('data').customPOST({ archived: true })
            }else{
            }
        }

        return emp.put()
    }

    public getWhoHaveBirthdayInMonth(fn: any) {
        this.Api.one('employees').get({'birth_date__in_7_days': '1'}).then((response) => {
            (fn || angular.noop)(response);
        }, () => {
            (fn || angular.noop)(false);
        });
    }

    private convert(obj, page, org_id?: string) {
        var result : any = { extra: {}, page: page, org: org_id }
        for (let key in this.availableFilters) {

            if (_.includes(["office","division","department"],key) && typeof(obj[key]) !== "object") {
              result[key] = obj[key]
              continue;
            }

            switch (this.availableFilters[key].type) {
                case 'checkbox': {
                    result.extra[key] = _.filter(_.map(obj[key], (v, k) => {
                        if(v) {return k} else {return null}}))
                } break;
                case 'date_range': {
                    if (obj.birth_date__lte > 0) {
                        result.birth_date__lte = moment().add(
                            -obj.birth_date__lte, 'years').format('YYYY-MM-DD')
                    }
                    if (obj.birth_date__gte > 0) {
                        result.birth_date__gte = moment().add(
                            -obj.birth_date__gte, 'years').format('YYYY-MM-DD')
                    }
                } break;
                case 'roles': {
                    if (obj[key]) {
                        result[obj[key]] = true;
                    }
                } break;
                default: {
                    result.extra[key] = obj[key]
                } break;
            }
            if (this.availableFilters[key].notInExtra) {
                result[key] = result.extra[key]
                delete result.extra[key]
            }
        }

        if (this.query) {
          result['query'] = this.query
        }

        if (this.query_email) {
          result['query_email'] = this.query_email
        }

        if (this.query_all_emp) {
            result['all_employees'] = true
        }
        return result
    }

    public postLeave(id: string, leave: any) : ng.IPromise<any> {
        return this.$http.post('/api/employees/'+id+'/leaves', leave)
    }

    public postLeaveBalanceCheck(id: string, leave: any) : ng.IPromise<any> {
        return this.$http.post('/api/employees/'+id+'/leave_balance', leave)
    }

    public all(org_id?: string, page = 1) {
        this.employees.loading = true;
        let promise = this.Api.all('employees').customGET("", {org: org_id, page: page})

        promise.then((response: any) => {
            this.employees.loading = false;
            this.employees.list = response.results;
            this.employees.count = response.count;
        });

        return promise;
    }

    public allEmployees(org_id?: string, page = 1) {
        this.employees.loading = true;
        let promise = this.Api.all('employees').customGET("", {org: org_id, page: page, 'list_all_employees': true})

        promise.then((response: any) => {
            this.employees.loading = false;
            this.employees.list = response.results;
            this.employees.count = response.count;
        });

        return promise;
    }

    public allNonEmployees(org_id: string) : ng.IPromise<any> {

      this.employees.loading = true;
      let promise = this.Api.all('employees').customGET("", {org: org_id, 'list_non_employees': true})
      promise.then((response: any) => {
          this.employees.loading = false;
          this.employees.list = response.results;
          this.employees.count = response.count;
      });

      return promise;

    }

    public allEmployeesAssignments(org_id: string) : ng.IPromise<any> {

      this.employees.loading = true;
      let promise = this.Api.all('employees').customGET("", {org: org_id, 'list_all_employees_assignments': true})
      promise.then((response: any) => {
          this.employees.loading = false;
          this.employees.list = response.results;
          this.employees.count = response.count;
      });

      return promise;

    }

    public names(q: string, org_id?: string) {
        if (!this.employeeNames.loading) {
            this.employeeNames.loading = true;
            this.employeeNames.promise = this.Api.all(
                'employees/names').getList({ org: org_id });

            this.employeeNames.promise.then((response: any) => {
                this.employeeNames.loading = false;
                this.employeeNames.list = response;
            }, (response) => {
                this.employeeNames.loading = false
            });
        }
        return this.employeeNames.promise;
    }

    public dismissTour(employee) : ng.IPromise<any> {
        employee.extra.dismiss_tour = true
        employee.extra.employment = employee.extra.employment ? employee.extra.employment : {}
        employee.extra.personal = employee.extra.personal ? employee.extra.personal : {}
        return this.$http.patch('/api/employees/'+employee.id, employee)
    }

    public setInviteEmailSent(employee) : ng.IPromise<any> {
        employee.extra.invite_email = true
        employee.extra.employment = employee.extra.employment ? employee.extra.employment : {}
        employee.extra.personal = employee.extra.personal ? employee.extra.personal : {}
        return this.$http.patch('/api/employees/'+employee.id, employee)
    }

    public updateData(employee_id: string, data: any, org_id: string) : ng.IPromise<any> {
      data.org_id = org_id
      data.send_clearance_email = true
      data.extra.employment = data.extra.employment || {}
      data.extra.personal = data.extra.personal || {}
      return this.$http.patch('/api/employees/'+employee_id, data)
    }

    public updateLeave(employee_id: string, bin_id: string, config_key: string, config_value: number): ng.IPromise<any> {
        let data = {
            bin_id,
            config_key,
            config_value
        }

        return this.$http.post('/api/employees/' + employee_id + '/leave_config', data);
    }


    public updateSelf(employee: any) : ng.IPromise<any> {
        employee.extra.employment = employee.extra.employment ? employee.extra.employment : {}
        employee.extra.personal = employee.extra.personal ? employee.extra.personal : {}
      return this.$http.patch('/api/employees/'+employee.id, employee)
    }

    public set_clearance(employee_id: string, clearance: string, new_employee?: boolean) : ng.IPromise<any> {
        var clearance_obj = { user: { clearance: clearance }, new_user: new_employee};
        return this.$http.patch('/api/employees/'+employee_id, clearance_obj);
    }

    public updateHelpBoxViews(employee) : ng.IPromise<any> {
        employee.extra.employment = employee.extra.employment ? employee.extra.employment : {}
        employee.extra.personal = employee.extra.personal ? employee.extra.personal : {}
        return this.$http.patch('/api/employees/'+employee.id, employee)
    }

    public updateAnnouncements(employee, announcements) : ng.IPromise<any> {
        if (employee.extra.announcements) {
            employee.extra.announcements = employee.extra.announcements.concat(announcements)
        } else {
            employee.extra.announcements = announcements
        }
        employee.extra.employment = employee.extra.employment ? employee.extra.employment : {}
        employee.extra.personal = employee.extra.personal ? employee.extra.personal : {}
        return this.$http.patch('/api/employees/'+employee.id, employee)
    }

    public updateAssignments(assignments) : ng.IPromise<any> {
        return this.$http.post('/api/employees/assignments', assignments);
    }

    public acceptToS(employee) : ng.IPromise<any> {
        employee.extra.terms_of_service = employee.extra.terms_of_service ? employee.extra.terms_of_service : {}
        employee.extra.terms_of_service.tac_agreed = true
        employee.extra.terms_of_service.tac_agreed_on = moment().format('YYYY-MM-DD')
        return this.$http.patch('/api/employees/'+employee.id, employee)
    }

    public acceptPrivacyPolicy(employee) : ng.IPromise<any> {
        employee.extra.terms_of_service = employee.extra.terms_of_service ? employee.extra.terms_of_service : {}
        employee.extra.terms_of_service.pp_agreed = true
        employee.extra.terms_of_service.pp_agreed_on = moment().format('YYYY-MM-DD')
        return this.$http.patch('/api/employees/'+employee.id, employee)
    }

    public dismissAnnouncementV3(employee) : ng.IPromise<any> {
        if (!employee.extra.dismiss_announcement_v3) {
            employee.extra['dismiss_announcement_v3'] = false;
        }
        employee.extra.dismiss_announcement_v3 = true;
        return this.$http.patch('/api/employees/'+employee.id, employee)
    }

    public createNote(employee:any, by_employee:any, note:string) : ng.IPromise<any> {
        employee.extra.notes = employee.extra.notes ? employee.extra.notes : [];
        var new_note = {
            'create_date': moment().format('YYYY-MM-DD HH:mm:ss'),
            'employee': by_employee.displayname,
            'employee_id': by_employee.id,
            'note': note
        }
        employee.extra.notes.push(new_note);
        return this.$http.patch('/api/employees/'+employee.id, employee)
    }
// TO DO (add deleted field to notes in employee schema)
    public deleteNote(note: any, emp:any, by_employee:any): Restangular.IPromise<any> {
        note.deleted = true;

        return emp.put()
    }





    public inlineUpdateInformation(employeeInLineInfo: any): Restangular.IPromise<any> {
        //new should send to the api the new inline update info.
        return this.Api.one('employees').get({'': '1'});
    }


    //we will have to change this to do the following
    /**
     * things to send to the API:
     * employeeId,
     * fieldName,
     * old value,
     * new value,
     * employeeDataVersionId 
     **/


    // Late Arrival Service

    public createLateEntry(employee:any, by_employee:any, createDate:any, expected_arrival_time:any, arrival_time:any, reason:string) : ng.IPromise<any> {
        employee.extra.lateArrivals = employee.extra.lateArrivals ? employee.extra.lateArrivals : [];
        var new_lateEntry = {
            'create_date': createDate,
            'employee': by_employee.displayname,
            'employee_id': by_employee.id,
            'arrival_time': arrival_time,
            'expected_arrival_time': expected_arrival_time,
            'reason': reason
        }
        employee.extra.lateArrivals.push(new_lateEntry);
        return this.$http.patch('/api/employees/' + employee.id, employee);
    }

    public autoPassportUpload(emp: any, file: any): Restangular.IPromise<any> {
        /* replace with real data response */
        return this.test_data;
    }
    //The service is inhouse, for the frontend and lets all controlers track and access the status of the tour for an employee.
    //This should not get or set anything from the backend.
    public setCoTourStatus(value: Boolean): any {
        this.coTourStatus = value;
    }

    public getCoTourStatus(): any {
        return this.coTourStatus;
    }

    public sendMassInvites(org_id: string) : any {
    }

    public updateSalary(salary: object): ng.IPromise<any> {
        return this.$http.put('/api/employees/salary_update', this.Api.stripRestangular(salary));
    }

}


angular.module('beneple.global')
    .service('Employee', EmployeeService);



// WEBPACK FOOTER //
// ./frontend/scripts/employee/services/employee.service.ts